module.exports = __webpack_public_path__ + "img/ts12.86e2f4fa.png";